import { ValueOf } from 'modules/Monitoring/types'

export const AttendanceVariants = {
  Scheduled: 'scheduled',
  Adherence: 'adherence',
} as const

export type AttendanceVariant = ValueOf<typeof AttendanceVariants>
